// extracted by mini-css-extract-plugin
export default {"switch":"SwitchSmall_switch__tA9L8","slider":"SwitchSmall_slider__LsuK1"};